import { AisSitesType } from "../hook/use-bxp-web-stargate-client.types";

/**
 * Filter out internal/invalid sites
 */

type IsValidSiteType = {
    readonly site: AisSitesType;
    readonly includeInvalidBitbucketSite?: boolean;
};

export const isValidSite = ({
    site,
    includeInvalidBitbucketSite
}: IsValidSiteType): boolean => {
    const ignoreSiteNames = [
        "servicedog",
        "ecosystem",
        "atlassiantraining",
        "Atlassian Stride",
        "volunteerhub",
        "atlassiantraining",
        "hello-staging",
        "ecosystem",
        "riskmanagement",
        "hello-staging3",
        "hello-staging6",
        "hello-staging9",
        "jdog",
        "sre-ehlo",
        "trello",
        "Trello"
    ];

    if (!includeInvalidBitbucketSite) {
        ignoreSiteNames.push("bitbucket", "Bitbucket");
    }

    if (ignoreSiteNames.includes(site.displayName)) {
        return false;
    }

    if (site.cloudId.startsWith("DUMMY")) {
        return false;
    }

    return true;
};
